import React from "react";
import CardSection from "./card_section/CardSection";
import ExperiencePower from "../../../gallary_showcase/experience_power/ExperiencePower";
import What_Customer_Say from "../../../home/what-customer-say/What_Customer_Say";
import "./All.css";
export default function All({setActive}) {
  return (
    <section className="">
      <CardSection setActive={setActive}/>
      <ExperiencePower />
      {/* <CardSection /> */}
      <div className="margin-top-wrapper-div">
        <What_Customer_Say />
      </div>
    </section>
  );
}
